import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';
import classnames from 'classnames';
import styles from '../styles.module.css';
import type { ScrollDirection } from '../types';

interface ScrollArrowProps {
  direction: ScrollDirection;
  isVisible: boolean;
  onClick: () => void;
  iconSize?: number;
}

export const ScrollArrow: React.FC<ScrollArrowProps> = ({
  direction,
  isVisible,
  onClick,
  iconSize = 28
}) => {
  const Icon = direction === 'left' ? ChevronLeft : ChevronRight;
  const arrowClass =
  direction === 'left' ? styles.leftArrow : styles.rightArrow;

  return (
    <button
      type="button"
      className={classnames(styles.arrow, arrowClass)}
      onClick={onClick}
      aria-label={`Scroll ${direction}`}
      aria-hidden={!isVisible}
      tabIndex={isVisible ? 0 : -1}
      disabled={!isVisible}>

			<Icon size={iconSize} aria-hidden="true" />
		</button>);

};